import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useScrollLock } from "../../hooks/useScrollLock";
import { useEffect } from "react";
import { showModal } from "../../features/modal/modalSlice";
import styled from "styled-components";
import PageTopTitle from "../shared/PageTopTitle";
import Button from "../shared/button/Btn";
import {
  getUyeMeslekiYeterlilik,
  getUyeninBagliOlduguUyeler,
  piyasaBilgisiGetir,
} from "../../features/uyelerAraclar/uyelerAraclarSlice";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 600px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    padding-top: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      padding: 40px 0;
      width: 800px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
  }
`;

const UyeIslemleriOptionsModal = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const { uyeItemData } = useSelector((state) => state.uyelerAraclar);

  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  return (
    <ModalContainer onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Üye İşlemleri"} />
        <div className="content">
        <Button
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("adminUyeGuncelle"));
            }}
          >
            Üyeyi Güncelle
          </Button>
          <Button
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("uyeBelgeleri"));
            }}
          >
            Üye Belgeleri
          </Button>
          <Button
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {}}
          >
            Üye Araçları
          </Button>
          <Button
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("addUyeSurucu"));
            }}
          >
            Sürücü Ekle
          </Button>
          <Button
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("uyeCalismaSekliYerleri"));
            }}
          >
            Çalışma Şekli ve Çalışılan Yerler
          </Button>

          <Button
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={(e) => {
              e.stopPropagation();
              dispatch(getUyeninBagliOlduguUyeler(uyeItemData.id));
              dispatch(showModal("uyeIsvereni"));
            }}
          >
            İş Vereni
          </Button>
          <Button
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={(e) => {
              e.stopPropagation();
              dispatch(getUyeMeslekiYeterlilik(uyeItemData.tckn));
              dispatch(showModal("uyeMeslekiYeterlilik"));
            }}
          >
            SRC Sorgula
          </Button>
          <Button
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {}}
          >
            Üyeyi Sil
          </Button>
          <Button
            color={"#E85546"}
            background={"transparent"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => dispatch(showModal(null))}
          >
            Geri Dön
          </Button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default UyeIslemleriOptionsModal;
